import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";
import store from "../store/store";
import { toggleState } from "../reducers/slices/ophRefreshSlice";

export const fetchOPHListByTier = (dispatch, tierId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_OPH_LIST_BY_TIER + tierId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_OPH_LIST_BY_TIER, payload: res.data });
  });
};

export const fetchOPHbyId = (dispatch, tierId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_OPH_BY_ID + tierId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_OPH_BY_ID, payload: res.data });
    }
  );
};

export const updateOPHStatus = (dispatch, message) => {
  dispatch({ type: ACTION_TYPES.FETCH_OPH_BY_ID, payload: message });
};
export const fetchShiftSchedule = (dispatch, tierId, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_SHIFTSCHEDULE +
      siteId +
      "&tierId=" +
      tierId +
      "&isStdDay=true",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_SHIFTSCHEDULE, payload: res.data });
  });
};

export const fetchColors = (dispatch, props) => {
  AsyncCallHandler(
    "digitaltier/getOPHColorCodebyReasonCode?siteid=" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_COLORS", payload: res.data });
  });
};

export const fetchOPHDetails = (dispatch, site, tier, ophDate, isStdDay) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_OPH_DETAILS +
      site +
      "&tierId=" +
      tier +
      "&ophDate=" +
      ophDate +
      "&isStdDay=" +
      isStdDay,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_OPH_DETAILS, payload: res.data });
  });
};

export const getOPHGraphDetailsById = (
  dispatch,
  tierId,
  startDate,
  endDate
) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_OPH_GRAPH_DATA_BY_ID +
      tierId +
      "&startDate=" +
      startDate +
      "&toDate=" +
      endDate,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_OPH_BY_ID, payload: res.data });
  });
};

export const exportOPHData = (name, url, inputData = null) => {
  AsyncCallHandler(url, NEXUS_CONST.POST, inputData, NEXUS_CONST.BLOB).then(
    (res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }
  );
};

export const saveTaktMaterialInfo = (dispatch, data) => {
  AsyncCallHandler(
    "DigitalTier/manageOPHMaterialDetails",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({ type: "FETCH_OPH_TAKT_DATA", payload: res.data });
    store.dispatch(toggleState());
  });
};

export const getTaktCardInfo = (dispatch, props) => {
  AsyncCallHandler(
    "DigitalTier/getTaktCardMaterialDetails?tierId=" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_OPH_TAKT_INFO", payload: res.data });
  });
};

export const getMaterials = (dispatch, tier) => {
  AsyncCallHandler(
    "DigitalTier/GetMaterialListbyTierID?tierId=" + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_MATERIALS", payload: res.data });
  });
};

export const getLevel0 = (dispatch, tier) => {
  AsyncCallHandler(
    "DigitalTier/GetOPHReasoncodeListData?level=0&TierID=" + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_LEVEL0", payload: res.data });
  });
};

export const getLevel1 = (dispatch, tier) => {
  AsyncCallHandler(
    "DigitalTier/GetOPHReasoncodeListData?level=1&TierID=" + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_LEVEL1", payload: res.data });
  });
};

export const getLevel2 = (dispatch, tier) => {
  AsyncCallHandler(
    "DigitalTier/GetOPHReasoncodeListData?level=2&TierID=" + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_LEVEL2", payload: res.data });
  });
};

export const fetchOphMissReasonGraphData = (dispatch, payload) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_OPH_MISS_REASON_GRAPH +
      payload.tier +
      "&startDate=" +
      payload.startDate +
      "&toDate=" +
      payload.endDate +
      "&rowcount=" +
      payload.rowcount +
      "&type=" +
      payload.type +
      "&iscascaded=" +
      payload.isCascaded +
      "&reasonLevel=" +
      payload.reasonLevel,
    NEXUS_CONST.GET
  ).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: ACTION_TYPES.FETCH_OPH_MISS_REASON_GRAPH,
        payload: res.data,
      });
    }
  });
};

export const fetchOphAttainmentGraphData = (dispatch, payload) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_OPH_ATTAINMENT_GRAPH +
      payload.tierId +
      "&startDate=" +
      payload.startDate,
    NEXUS_CONST.GET
  ).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: ACTION_TYPES.FETCH_OPH_ATTAINMENT_GRAPH,
        payload: res.data,
      });
    }
  });
};
